<template>
  <div>
    <h1>Modifier le domaine</h1>

    <form
      @submit.prevent="submit"
      class="clearfix"
    >
      <div class="mt-4">Domain</div>
      <input
        v-model="domain.hostname"
        placeholder="hostname"
        class="block w-full bg-gray-100 py-2 px-4 border-solid border border-gray-300 rounded mb-2"
      >

      <div class="mt-4">Name</div>
      <input
        v-model="domain.name"
        placeholder="hostname"
        class="block w-full bg-gray-100 py-2 px-4 border-solid border border-gray-300 rounded mb-2"
      >

      <div class="mt-4">Banner</div>
      <input
        v-model="domain.banner"
        placeholder="banner"
        class="block w-full bg-gray-100 py-2 px-4 border-solid border border-gray-300 rounded mb-2"
      >

      <div class="mt-4">Color</div>
      <input
        v-model="domain.color"
        placeholder="color"
        class="block w-full bg-gray-100 py-2 px-4 border-solid border border-gray-300 rounded mb-2"
      >

      <div class="mt-4">Vidéo tuto inscription</div>
      <input
        v-model="domain.tuto_video_inscription"
        placeholder="Vidéo tuto inscription"
        class="block w-full bg-gray-100 py-2 px-4 border-solid border border-gray-300 rounded mb-2"
      >

      <div class="mt-4">Vidéo tuto hors inscription</div>
      <input
        v-model="domain.tuto_video_hors_inscription"
        placeholder="Vidéo tuto hors inscription"
        class="block w-full bg-gray-100 py-2 px-4 border-solid border border-gray-300 rounded mb-2"
      >

      <div class="mt-4">Banner</div>
      <input
        v-model="domain.banner"
        placeholder="banner"
        class="block w-full bg-gray-100 py-2 px-4 border-solid border border-gray-300 rounded mb-2"
      >

      <div class="mt-4">Custom Message</div>
      <textarea
        v-model="domain.custom_message_ec"
        placeholder="Custom message"
        class="block w-full bg-gray-100 py-2 px-4 border-solid border border-gray-300 rounded mb-2 h-48"
        />

      <!-- paying domain  -->
      <div class="mt-4">PayingDomain</div>
      <input
        type="radio"
        id="true" value="true"
        v-model="domain.paying_domain"
      >
      <label
        class="ml-1"
        for="true"
      >
        true
      </label>

      <input
        type="radio"
        id="false"
        value="false"
        class="ml-4"
        v-model="domain.paying_domain"
      >
      <label
        class="ml-1"
        for="false"
      >
        false
      </label>

      <!-- editable ec  -->
      <div class="mt-4">editableEc</div>
      <input
        type="radio"
        id="true" value="true"
        v-model="domain.editable_ec"
      >
      <label
        class="ml-1"
        for="true"
      >
        true
      </label>

      <input
        type="radio"
        id="false"
        value="false"
        class="ml-4"
        v-model="domain.editable_ec"
      >
      <label
        class="ml-1"
        for="false"
      >
        false
      </label>

      <!-- checkboxes -->
      <div>
        <div class="mt-4">Others</div>
        <div
          v-for="(service, index) of services"
          :key="index"
        >
          <input
            type="checkbox"
            v-model="domain.services"
            :value="service.id"
            :checked="domain.services.includes(service.id)"
            class="mr-2"
          >

          <label>{{ service.name }}</label>
        </div>
      </div>

      <button
        type="submit"
        class="bg-blue-500 hover:bg-blue-600 px-4 py-2 rounded text-white shadow float-right"
      >
        Modifier domaine
      </button>

    </form>

    <Error
      v-if="error"
      v-bind="error"
    />
  </div>
</template>

<script>
import Error from '@/components/Error'

export default {
  components: {
    Error
  },

  data() {
    return {
      error: null,
      domain: {
        hostname: null,
        banner: null,
        color: null,
        services: [],
        paying_domain: null,
        custom_message_ec: null,
        editable_ec: true,
        tuto_video_inscription: null,
        tuto_video_hors_inscription: null
      },
      services: []
    }
  },

  async mounted() {
    const domain = await this.$axios.get(`/domains/${this.$route.params.id}`)
    console.log(domain.data)
    this.domain = domain.data

    const services = await this.$axios.get('/services')
    this.services = services.data
  },

  methods: {
    async submit() {
      const params = {
        domain: this.domain
      }

      try {
        await this.$axios.patch(`/domains/${this.$route.params.id}`, params)

        this.err = null

        this.$router.push('/domaines')
      } catch (err) {
        this.error = err.response.data
      }
    }
  }
}
</script>
